import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const sandboxBundlerBifrostEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-sandbox-bundler-entrypoints", jiraSpaEntry: "async-sandbox-bundler-entrypoints" */ './src/index.tsx'
			),
	),
	getPreloadProps: () => ({}),
});
